import { render, staticRenderFns } from "./LmFormSeparator.vue?vue&type=template&id=164eddfb&scoped=true"
import script from "./LmFormSeparator.vue?vue&type=script&lang=js"
export * from "./LmFormSeparator.vue?vue&type=script&lang=js"
import style0 from "./LmFormSeparator.vue?vue&type=style&index=0&id=164eddfb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164eddfb",
  null
  
)

export default component.exports